import Vue from 'vue'
import App from './App.vue'
import api from './services/api'
import router from './router'
import store from './store'
import './services'
import './scss/index.scss'
import VueScroller from 'vue-scroller'
// import VueClipboards from 'vue-clipboards'
import NavBtn from '@/components/NavBtn'
// Vue.use(VueClipboards)
Vue.use(VueScroller)
// 全局变量注册
window.$api = api
window.$router = router

// 全局组件
Vue.component('NavBtn', NavBtn) // 导航按钮

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
